import { useTranslation } from 'react-i18next';
import { Anchor, Box, Table, Text } from '@mantine/core';

import type { OrganisationType } from 'types';

type Props = {
  organisation: OrganisationType;
};

export const CompanyData = ({ organisation }: Props) => {
  const { t } = useTranslation('organisations');

  const allFieldsEmpty = Object.entries(organisation.details).every(
    ([key, value]) => key === 'logoUrl' || value === null || value === '',
  );

  console.log(allFieldsEmpty);

  if (allFieldsEmpty) return null;

  return (
    <Box>
      <Text mb="xs" fw="bold">
        {organisation.details.name}
      </Text>
      <Text mb="xs">{organisation.details.street}</Text>
      <Text mb="md">
        {organisation.details.postalCode} {organisation.details.city}
      </Text>
      <Text mb="xs">
        {organisation.details.website && (
          <Anchor
            href={organisation.details.website}
            target="_blank"
            fz="inherit"
          >
            {organisation.details.website}
          </Anchor>
        )}
      </Text>
    </Box>
  );
};
